<template>
  <div class="notice-detail-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <router-link to="/noticelist">通知公告</router-link> &gt;
        <span>通知公告详情</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <article class="detail-card card-modern">
        <header class="detail-header">
          <h1 class="title">{{ noticeDetail.title }}</h1>
          <div class="meta-info">
            <span
              ><i class="el-icon-time"></i> 发布时间：{{
                noticeDetail.releaseTime
                  ? noticeDetail.releaseTime.slice(0, 10)
                  : "暂无"
              }}</span
            >
          </div>
        </header>

        <div
          class="detail-body rich-text-content"
          v-html="noticeDetail.content"
        ></div>
      </article>
    </main>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import article from "@/api/article";

export default {
  name: "NoticeDetail",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("../assets/images/newsbanner.jpg"),
      noticeDetail: {},
    };
  },
  created() {
    if (this.$route.query) {
      let id = this.$route.query.id;
      this.getList(id);
    }
  },
  methods: {
    getList(id) {
      article
        .getNoticeDetail({ id: id })
        .then((res) => {
          this.noticeDetail = res.data.data;
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables.less";

.notice-detail-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

.detail-card {
  background: #ffffff;
  padding: 60px 80px;
  border-radius: @border-radius;
}

.detail-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid @border-color;

  .title {
    font-size: 28px;
    font-weight: 700;
    color: @text-main;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .meta-info {
    font-size: 14px;
    color: @text-muted;
    display: flex;
    justify-content: center;
    gap: 24px;
    i {
      margin-right: 4px;
    }
  }
}

.detail-body {
  font-size: 16px;
  line-height: 1.8;
  color: @text-secondary;
  min-height: 400px;

  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
    border-radius: 4px;
    margin: 24px 0;
  }

  /deep/ p {
    margin-bottom: 16px;
  }
}

.detail-footer {
  margin-top: 60px;
  padding-top: 32px;
  border-top: 1px solid @border-color;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .detail-card {
    padding: 32px 20px;
  }
  .detail-header .title {
    font-size: 22px;
  }
}
</style>
